/*
 * Application Insights JavaScript SDK - React Plugin, 19.3.8
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ import { createContext, useContext } from "react";
var AppInsightsContext = /*#__PURE__*/ createContext(undefined);
var useAppInsightsContext = function useAppInsightsContext() {
    return useContext(AppInsightsContext);
};
export { AppInsightsContext, useAppInsightsContext }; //# sourceMappingURL=AppInsightsContext.js.map
